import React from "react";
import CodeEditorMock from "../Panels/CodeEditorMock";

const MertCloud = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          mertCloud
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content single-project">
        <div className="left">
          <CodeEditorMock>
            Created a{" "}
            <span class="function-color op-1">
              personal cloud storage platform
            </span>{" "}
            named <span class="html-color-text op-1">mertCloud</span>, developed
            to{" "}
            <span class="string-color-text op-1">
              upload, manage, and access files
            </span>{" "}
            seamlessly from any device.
            <br />
            <br />
            Implemented a{" "}
            <span class="function-color op-1">
              chunked file upload mechanism
            </span>{" "}
            using <span class="nodejs-color-text op-1">multer</span> and{" "}
            <span class="nodejs-color-text op-1">Express</span> to{" "}
            <span class="docker-color-text op-1">optimize performance</span> and
            handle{" "}
            <span class="string-color-text op-1">large files efficiently</span>.
            The backend architecture supports{" "}
            <span class="function-color op-1">file validation</span>,{" "}
            <span class="function-color op-1">chunk merging</span>, and{" "}
            <span class="function-color op-1">progress tracking</span> for a
            smooth user experience.
            <br />
            <br />
            Built entirely with{" "}
            <span class="nodejs-color-text op-1">Node.js</span> and{" "}
            <span class="nodejs-color-text op-1">Express</span> on the server
            side, ensuring{" "}
            <span class="docker-color-text op-1">
              scalable and modular architecture
            </span>
            . File metadata is stored securely, and the system is designed with{" "}
            <span class="function-color op-1">authentication support</span> for
            future multi-user capabilities.
            <br />
            <br />
            The frontend was built using{" "}
            <span class="react-color-text op-1">React</span>, with a{" "}
            <span class="function-color op-1">drag-and-drop UI</span> for file
            uploads and{" "}
            <span class="string-color-text op-1">
              real-time feedback on upload status
            </span>
            . Users can{" "}
            <span class="function-color op-1">upload any file type</span>, view{" "}
            <span class="string-color-text op-1">upload history</span>, and
            enjoy{" "}
            <span class="google-color-text op-1">responsive performance</span>{" "}
            thanks to the chunked architecture.
          </CodeEditorMock>
        </div>
        <div className="right">
          <p className="comment">// Short code snippet for uploading files</p>
          <div className="box-container">
            <CodeEditorMock>
              <span class="const-color">const</span>{" "}
              <span class="function-color">uploadChunk</span> ={" "}
              <span class="const-color">async</span> (req, res) =&gt; {"{"}
              <br />
              &nbsp;&nbsp;<span class="const-color">try</span> {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;const {"{"} chunkIndex, totalChunks,
              fileName {"}"} = req.body;
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;const chunk = req.files?.chunk;
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">if</span>{" "}
              (!chunk || chunk.size === 0) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;return res.status(400).json(
              {"{"} message:{" "}
              <span class="string-color-text">"Invalid or empty chunk"</span>{" "}
              {"}"});
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;console.log(`Received chunk ${"{"}
              chunkIndex + 1{"}"}/${"{"}totalChunks{"}"}`);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;const tempDir = path.join(__dirname,{" "}
              <span class="string-color-text">"../uploads/temp"</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">if</span>{" "}
              (!fs.existsSync(tempDir)) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fs.mkdirSync(tempDir, {
                "{"
              }{" "}
              recursive: <span class="boolean-color-text">true</span> {"}"});
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;const tempFilePath = path.join(tempDir, `$
              {"{"}fileName{"}"}.tmp`);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;fs.appendFileSync(tempFilePath,
              chunk.data);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;console.log(`Chunk ${"{"}chunkIndex + 1
              {"}"}/${"{"}totalChunks{"}"} appended.`);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span class="const-color">if</span>{" "}
              (parseInt(chunkIndex) === parseInt(totalChunks) - 1) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;const finalDir =
              path.join(__dirname,{" "}
              <span class="string-color-text">"../uploads"</span>);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="const-color">
                if
              </span> (!fs.existsSync(finalDir)) {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fs.mkdirSync(finalDir,{" "}
              {"{"} recursive: <span class="boolean-color-text">true</span>{" "}
              {"}"});
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;const finalFilePath =
              path.join(finalDir, fileName);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fs.renameSync(tempFilePath,
              finalFilePath);
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;console.log(`File ${"{"}
              fileName{"}"} finalized.`);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;{"}"}
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;res.status(200).json({"{"} message:{" "}
              <span class="string-color-text">
                "Chunk uploaded successfully."
              </span>{" "}
              {"}"});
              <br />
              &nbsp;&nbsp;{"}"} <span class="const-color">catch</span> (error){" "}
              {"{"}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;console.error(
              <span class="string-color-text">"Error uploading chunk:"</span>,
              error);
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;res.status(500).json({"{"} message:{" "}
              <span class="string-color-text">"Failed to upload chunk"</span>,
              error: error.message {"}"});
              <br />
              &nbsp;&nbsp;{"}"}
              <br />
              {"}"};
            </CodeEditorMock>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MertCloud;
